import styled from '@emotion/styled';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

import { graphColorsPalette } from '../../constant/color';

type Props = {
  data: any;
  label: string;
  className?: string;
};

const DailyPerformanceGraph: FC<Props> = ({
  data,
  label,
  className,
}: {
  data: any;
  label: string;
  className?: string;
}) => {
  const formatKeys: any = [];

  data.forEach((target: any) => {
    const keys = Object.keys(target);
    keys.forEach((key: string) => {
      if (formatKeys.indexOf(key) === -1 && key !== 'date') {
        formatKeys.push(key);
      }
    });
  });

  return (
    <Root className={className}>
      {data.length !== 0 ? (
        <>
          <Label>
            <FormattedMessage id={label} />
          </Label>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={data}>
              <XAxis dataKey="date" hide={true} />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip />
              <Legend />
              {formatKeys.map((key: string, index: number) => (
                <Line
                  key={index}
                  type="monotone"
                  dataKey={key}
                  stroke={graphColorsPalette[index % graphColorsPalette.length]}
                  dot={false}
                  activeDot={{ r: 3 }}
                />
              ))}
            </LineChart>
          </ResponsiveContainer>
        </>
      ) : (
        <Blank>
          <FormattedMessage id={label} />
          <FormattedMessage id="adAnalytics_detail.performance_nothing_message" />
        </Blank>
      )}
    </Root>
  );
};

const Root = styled('div')({
  width: '300px',
  marginRight: '16px',
  marginBottom: '32px',
});

const Blank = styled('div')({
  width: '100%',
  height: '200px',
  border: 'solid 1px #999',
  color: '#999',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '16px',
  fontSize: '12px',
  textAlign: 'center',
  wordBreak: 'break-word',
});

const Label = styled('div')({
  fontSize: '14px',
  color: 'rgba(0,0,0,.66)',
  fontWeight: 700,
  marginBottom: '8px',
});
export default DailyPerformanceGraph;
